import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCube = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 19,
	height: 19,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M21 8V16a2 2 0 0 1-1 1.73l-7 4a2 2 0 0 1-2 0l-7-4A2 2 0 0 1 3 16V8a2 2 0 0 1 1-1.73l7-4a2 2 0 0 1 2 0l7 4A2 2 0 0 1 21 8z" }),
		/* @__PURE__ */ _jsx("path", { d: "M3.3 7l8.7 5 8.7-5" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 22V12" })
	]
});
export default SvgCube;
